module.exports = __webpack_public_path__ + "img/hotstyleshow1.627894a5.jpg";